<template>
  <div>
    <div class="row">
      <h2>Lexicon suggestions</h2>
    </div>

    <div class="row float-right">
      <div class="col-md-12"><br />
        <label class="btn btn-success" @click.stop="onSubmitSuggestions()">
          Generate Build
        </label>&nbsp;
      </div>
    </div>

    <div class="row d-flex justify-content-center">
      <div v-if="this.requestCompleted && this.rows.length === 0">
        Builds list is empty, click on "Manage suggestion" to add to the list.<br />
      </div>
    </div>

    <div v-if="this.requestCompleted && this.rows.length === 0" class="row d-flex justify-content-center">
      <img src="@/assets/no-data.png" />
    </div>

    <div v-if="this.rows.length > 0">
      <grid :styles="gridStyle" :cols="cols" :rows="rows" :sort="true" :pagination="pagination" :search="search"></grid>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_saas.js'
import Grid from 'gridjs-vue'
import router from '../router'

export default {
  props: {
  },
  components: {
    Grid
  },
  data () {
    return {
      desc: {},
      rows: [],
      requestCompleted: false,
      groupId: 0,
      pagination: true,
      search: true,
      gridStyle: {
        table: {
          border: '3px solid #ccc'
        },
        th: {
          'background-color': 'rgba(0, 0, 0, 0.1)',
          color: '#000',
          'border-bottom': '3px solid #ccc',
          'text-align': 'center'
        },
        td: {
          'text-align': 'center'
        }
      },
      cols: [
        {
          name: 'Word',
          width: '30%',
          formatter: (cell, row) => {
            return this.$gridjs.html('<span><u>' + cell + '</u></span>')
          }
        },
        {
          name: 'Suggestions',
          width: '60%',
          formatter: (cell, row) => {
            return this.$gridjs.html('<input style="width: 100%;" type="text" value="' + cell + '" />')
          }
        }
      ]
    }
  },
  mounted: function () {
    this.groupId = this.$route.params.id
    apiClient.get('/api/lexicon/suggest/status/' + this.groupId).then((response) => {
      response.data.forEach((item, key) => {
        this.rows.push([
          item.word,
          item.like.join(', '),
          false
        ])
      })

      this.requestCompleted = true
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data)
      }
    })
  },
  methods: {
    navigateToLexiconWordsList: function () {
      router.push({ name: 'LexiconWords', params: { id: this.groupId } })
    },
    onManageSuggestions: function (event) {
      router.push({ name: 'LexiconSuggestionsManagement', params: { id: this.groupId } })
    }
  }
}
</script>
